var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3.75L5.57064 6.19811C7.1635 7.10063 7.8365 7.10063 9.42936 6.19811L13.75 3.75",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25985 8.42226C1.30071 10.3382 1.32114 11.2962 2.0281 12.0058C2.73505 12.7155 3.71896 12.7402 5.68677 12.7897C6.89957 12.8201 8.10043 12.8201 9.31324 12.7897C11.281 12.7402 12.265 12.7155 12.9719 12.0058C13.6789 11.2962 13.6993 10.3382 13.7401 8.42226C13.7533 7.80621 13.7533 7.1938 13.7401 6.57775C13.6993 4.66179 13.6789 3.70381 12.9719 2.99416C12.265 2.28452 11.281 2.2598 9.31324 2.21036C8.10043 2.17988 6.89957 2.17988 5.68676 2.21035C3.71896 2.25979 2.73505 2.28451 2.0281 2.99415C1.32114 3.7038 1.30071 4.66178 1.25985 6.57774C1.24672 7.19379 1.24672 7.80621 1.25985 8.42226Z",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail05);
export default __webpack_public_path__ + "static/media/mail-05.f70c81446687a000f3501079e63312fa.svg";
export { ForwardRef as ReactComponent };